import cn from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import ImmutablePropTypes from 'react-immutable-proptypes';
import { metadataIdFixer } from '@bibliocommons/utils-link';
import { bibJacketCoverAltText } from '@bibliocommons/utils-item';
import { RatingStars } from '@bibliocommons/rating';
import { bindAll } from '@bibliocommons/utils-react';
import BibBrief from 'app/components/shared/BibBrief';
import JacketCover from '@bibliocommons/shared-jacket-cover';
import { bibEventComposer } from '@bibliocommons/analytics-event-composers';
import { sendAnalyticsEvents } from '@bibliocommons/utils-analytics';
import BibSeries from 'app/components/shared/BibSeries';
import RecommendationsContainer from '../Recommendations/RecommendationsContainer';
import ManifestationList from '../ManifestationList';

const { composeImageClickEvent } = bibEventComposer;

class SearchResultItemContent extends React.PureComponent {
  constructor(props) {
    super(props);
    bindAll(this);
  }

  handleJacketClick() {
    const { reciprocalRank, item } = this.props;
    const metadataId = item.getIn(['briefInfo', 'metadataId']);

    sendAnalyticsEvents(
      composeImageClickEvent({
        containerName: 'bib-item',
        reciprocalRank,
        metadataId
      })
    );
  }

  renderSeries() {
    if (this.props.showSeries) {
      return (
        <span className="series-list">
          <p>
            <FormattedMessage id="series" />:
          </p>
          {this.props.item
            .getIn(['briefInfo', 'series'])
            .valueSeq()
            .map(series => (
              <BibSeries series={series} />
            ))}
        </span>
      );
    }
    return null;
  }

  renderManifestations() {
    return (
      <ManifestationList
        availabilityDetail={this.props.availabilityDetail}
        availabilityBib={this.props.item.get('briefInfo')}
        availabilityDetailActions={this.props.availabilityDetailActions}
        manifestations={this.props.manifestations}
        catalogSearchOptions={this.props.catalogSearchOptions}
        currentUser={this.props.currentUser}
        groupSearchFeedbackActions={this.props.groupSearchFeedbackActions}
        reciprocalRank={this.props.reciprocalRank}
      />
    );
  }

  render() {
    const bibTitle = this.props.item.getIn(['briefInfo', 'title']);
    const bibCoverAltText = bibJacketCoverAltText(bibTitle, this.props.item.getIn(['briefInfo', 'authors']));
    const jacketSource = this.props.item.getIn(['briefInfo', 'jacket']);
    const manifestations = this.props.manifestations;
    const searchResultItemContentClasses = cn('cp-search-result-item-content');
    const rating = this.props.item.getIn(['briefInfo', 'rating', 'averageRating']) || 0;
    const screenReaderLabel = <FormattedMessage id="screenReaderStarRating" values={{ rating: rating / 20 }} />;

    return (
      <div className={searchResultItemContentClasses}>
        <div className="cp-search-result-item-info">
          <div className="jacket-cover-wrap hidden-md hidden-lg">
            <a
              href={`/item/show/${metadataIdFixer(this.props.item.get('id'))}`}
              title={bibTitle}
              target="_parent"
              onClick={this.handleJacketClick}
            >
              <JacketCover
                src={jacketSource}
                format={this.props.item.getIn(['briefInfo', 'format'])}
                alt={bibCoverAltText}
              />
            </a>
          </div>
          <div>
            <BibBrief
              bib={this.props.item.get('briefInfo')}
              renderAuthorsAsLink
              reciprocalRank={this.props.reciprocalRank}
            >
              {this.renderSeries()}
            </BibBrief>
            {!!rating && <RatingStars rating={rating} screenReaderLabel={screenReaderLabel} />}
          </div>
        </div>

        <div className="info">
          <div className="row">
            <div className="col-12 col-xs-12 availability_status">{this.renderManifestations()}</div>
          </div>
        </div>
        <RecommendationsContainer manifestations={manifestations} />
      </div>
    );
  }
}

SearchResultItemContent.propTypes = {
  availabilityDetail: ImmutablePropTypes.map,
  item: ImmutablePropTypes.map,
  catalogSearchOptions: ImmutablePropTypes.map,
  currentUser: ImmutablePropTypes.map,
  showSeries: PropTypes.bool,
  reciprocalRank: PropTypes.number,
  groupSearchFeedbackActions: PropTypes.objectOf(PropTypes.func),
  availabilityDetailActions: PropTypes.objectOf(PropTypes.func),
  manifestations: ImmutablePropTypes.list
};

export default SearchResultItemContent;
